import "./form-buttons-wrap.scss";

const FormButtonsWrap = ({ children, vertical, center }) => (
  <div
    className={`form-buttons-wrap ${vertical ? "vertical" : ""} ${
      center ? "center" : ""
    }`}
  >
    {children}
  </div>
);

export default FormButtonsWrap;
